import { Box, Group } from '@mantine/core';
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import { HeightFittedStack } from '../../../../../react-commons/components/data-display/HeightFittedStack';
import { FormLike } from '../../../../../react-commons/hooks/useMultiForm';
import { Form_EditableDisplayBar } from './Form_EdiableDisplayBar';

export const Form_DisplayComponentBaseView = ({
                                                  form,
                                                  children,
                                                  canSubmitDefaultValue,
                                                  hideButtons,
                                                  onSubmit,
                                              }: PropsWithChildren<{
    form: FormLike;
    canSubmitDefaultValue: boolean;
    hideButtons?: boolean;
    onSubmit: ((e?: React.BaseSyntheticEvent | undefined) => Promise<void>) | undefined;
}>) => {
    return (
        <form style={{ height: '100%' }} onSubmit={onSubmit}>
            <HeightFittedStack>
                <Box h={'100%'} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                    {children}
                </Box>
                <Show when={!hideButtons}>
                    <Group justify="flex-end">
                        <Form_EditableDisplayBar form={form} canSubmitDefaultValue={canSubmitDefaultValue} />
                    </Group>
                </Show>
            </HeightFittedStack>
        </form>
    );
};
